import axios from 'axios';
import { createStore } from 'vuex'

export default createStore({
  state: {
    localhost: "https://api.cassuss.com/api/",
    baseUrl: "https://api.cassuss.com/product/product_images/",
    pageMeta: {
    title: '',
    description: '',
    keywords: '',
    image: '',
    type: 'website',
    robots: 'index, follow',
    product: null,
    category: null,
    canonical: ''
   
  },
    // Fournisseurs
    suppliers: [],
    adminSuppliers: [],
     resetEmail: '',
    // Dashboard data
    dashsuppliers: [],
    // Données utilisateur
    user: null,
    token: localStorage.getItem('token'),
    
    // Panier
    cart: [],
    productnumber: 0,
    // Commandes
    orders: [],
    
    // Wishlist
    wishlists: [],
    
    // Données produitproducts
    categories: [],
    brands: [],
    
    // Page d'accueil - Tous les produits
    allProducts: [],
    
    // Produits promotionnels pour la section hero (slider)
    heroPromoProducts: [],
    
    // Produits tendance
    trendingProducts: [],
    
    // Meilleures ventes
    bestsellerProducts: [],
    
    // Nouveautés
    newArrivals: [],
    
    // Promotions (produits en solde)
    promoProducts: [],
    
    // Produits similaires (pour page détail)
    similarProducts: [],
    
    // Données d'administration
    admin: {
      brands: [],
      categories: [],
      productModels: [],
      products: [],
      orders: [],
      users: [],
      suppliers: []
    },
    
    // Données dashboard
    dashproducts: [],
    dashcategories: [],
    dashcommandes: [],
    dashusers: [],
    dashbrands: [],
    dashorders: [],
    dashproductModels: [],
  },
  
  getters: {
      isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
    
     // Getters pour les fournisseurs
    suppliers: (state) => state.suppliers,
    adminSuppliers: (state) => state.adminSuppliers,
    adminSuppliersStats: (state) => ({
      totalSuppliers: state.adminSuppliers.length,
      activeSuppliers: state.adminSuppliers.filter(s => s.status === 'active').length,
      inactiveSuppliers: state.adminSuppliers.filter(s => s.status === 'inactive').length,
      totalProductsFromSuppliers: state.adminSuppliers.reduce((sum, s) => sum + (s.product_count || 0), 0),
      totalOrdersFromSuppliers: state.adminSuppliers.reduce((sum, s) => sum + (s.order_count || 0), 0),
    }),
    pageSchema: (state) => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': state.pageMeta.type === 'product' ? 'Product' : 'WebSite',
      name: state.pageMeta.title,
      description: state.pageMeta.description,
      url: window.location.href
    }
    
    if (state.pageMeta.type === 'product' && state.pageMeta.product) {
      const product = state.pageMeta.product
      schema.offers = {
        '@type': 'Offer',
        price: product.promo_price || product.price,
        priceCurrency: 'XAF',
        availability: product.in_stock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
        priceValidUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      }
      
      if (product.brand) {
        schema.brand = {
          '@type': 'Brand',
          name: product.brand.name
        }
      }
      
      if (product.category) {
        schema.category = product.category.name
      }
    }
    
    if (state.pageMeta.type === 'website' && state.pageMeta.category) {
      schema['@type'] = 'CollectionPage'
      schema.name = state.pageMeta.category.name
      schema.description = `Collection de produits ${state.pageMeta.category.name}`
    }
    
    return schema
  },
    // Getters pour l'administration
    adminBrands: (state) => state.admin.brands,
    adminCategories: (state) => state.admin.categories,
    adminProductModels: (state) => state.admin.productModels,
    adminProducts: (state) => state.admin.products,
    adminOrders: (state) => state.admin.orders,
    adminUsers: (state) => state.admin.users,
    adminStats: (state) => ({
      totalBrands: state.admin.brands.length,
      totalCategories: state.admin.categories.length,
      totalProducts: state.admin.products.length,
      totalOrders: state.admin.orders.length,
      totalUsers: state.admin.users.length,
      totalProductModels: state.admin.productModels.length
    }),
    
    // Getters utilisateur
    cartCount: (state) => state.cart.reduce((total, item) => total + item.quantity, 0),
    
    cartTotal: (state) => state.cart.reduce((total, item) => total + (item.product.price * item.quantity), 0),
    wishlistCount: (state) => state.wishlists.length,
    orderCount: (state) => state.orders.length,
    
    // Getters produits
    promoProductsCount: (state) => state.promoProducts.length,
    newArrivalsCount: (state) => state.newArrivals.length,
    categoriesCount: (state) => state.categories.length,
    brandsCount: (state) => state.brands.length,
    
    // Produits en promo (pour hero slider)
    heroPromoSlides: (state) => state.heroPromoProducts.slice(0, 4),
  },
  
  mutations: {
      setResetEmail(state, email) {
      state.resetEmail = email;
    },
    
    setToken(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    
    setUser(state, user) {
      state.user = user;
    },
    
    clearAuth(state) {
      state.token = null;
      state.user = null;
      state.resetEmail = '';
      localStorage.removeItem('token');
      localStorage.removeItem('rememberMe');
      localStorage.removeItem('userEmail');
    },
    setPageMeta(state, meta) {
    state.pageMeta = { ...state.pageMeta, ...meta }
  },
   // Mutations pour les fournisseurs
    setSuppliers(state, suppliers) {
      state.suppliers = suppliers;
    },
    
    setAdminSuppliers(state, suppliers) {
      state.adminSuppliers = suppliers;
    },
    
    addAdminSupplier(state, supplier) {
      state.adminSuppliers.push(supplier);
    },
    
    updateAdminSupplier(state, updatedSupplier) {
      const index = state.adminSuppliers.findIndex(s => s.id === updatedSupplier.id);
      if (index !== -1) {
        state.adminSuppliers.splice(index, 1, updatedSupplier);
      }
    },
    
    deleteAdminSupplier(state, id) {
      state.adminSuppliers = state.adminSuppliers.filter(s => s.id !== id);
    },
    
    // Dashboard mutations
    setDashboardSuppliers(state, suppliers) {
      state.dashsuppliers = suppliers;
    },
  clearPageMeta(state) {
    state.pageMeta = {
      title: '',
      description: '',
      keywords: '',
      image: '',
      type: 'website',
      robots: 'index, follow',
      product: null,
      category: null,
      canonical: ''
    }
  },
      // Mutations pour l'authentification
      setToken(state, token) {
        state.token = token;
        if (token) {
          localStorage.setItem('token', token);
        } else {
          localStorage.removeItem('token');
        }
      },
      
      setUser(state, user) {
        state.user = user;
      },
      
      clearAuth(state) {
        state.token = null;
        state.user = null;
        localStorage.removeItem('token');
      },
    
    // Mutations pour le panier
    setCart(state, cartItems) {
      state.cart = cartItems;
    },
    
    addToCart(state, cartItem) {
      // Vérifier si le produit existe déjà avec la même taille/couleur
      const existingItem = state.cart.find(item => 
        item.product_id === cartItem.product_id && 
        item.size === cartItem.size && 
        item.color === cartItem.color
      );
      
      if (existingItem) {
        existingItem.quantity += cartItem.quantity;
      } else {
        state.cart.push(cartItem);
        console.log( state.cart)
      }
    },
    
    updateCartItem(state, { id, updates }) {
      const item = state.cart.find(item => item.id === id);
      if (item) {
        Object.assign(item, updates);
      }
    },
    
    removeFromCart(state, id) {
      state.cart = state.cart.filter(item => item.id !== id);
    },
    
    clearCart(state) {
      state.cart = [];
    },
    
    incrementCartItem(state, id) {
      const item = state.cart.find(item => item.id === id);
      if (item) {
        item.quantity += 1;
      }
    },
    
    decrementCartItem(state, id) {
      const item = state.cart.find(item => item.id === id);
      if (item && item.quantity > 1) {
        item.quantity -= 1;
      }
    },
    
    // Mutations pour les commandes
    setOrders(state, orders) {
      console.log(orders)
      state.orders = orders;
    },
    
    addOrder(state, order) {
      state.orders.unshift(order);
    },
    
    updateOrderStatus(state, { id, status }) {
      const order = state.orders.find(order => order.id === id);
      if (order) {
        order.status = status;

        order.status_text = getStatusText(status);
      }
    },
    
    // Mutations pour la wishlist
    setWishlists(state, wishlists) {
      state.wishlists = wishlists;
    },
    
    addToWishlist(state, wishlistItem) {
      if (!state.wishlists.some(item => item.id === wishlistItem.id)) {
        state.wishlists.push(wishlistItem);
      }
    },
    
    removeFromWishlist(state, id) {
      state.wishlists = state.wishlists.filter(item => item.id !== id);
    },
    
    // Mutations pour les produits
    setAllProducts(state, products) {
      state.allProducts = products;
    },
    
    setCategories(state, categories) {
      state.categories = categories;
    },
    
    setBrands(state, brands) {
      state.brands = brands;
    },
    
    setPromoProducts(state, products) {
      state.promoProducts = products;
      // Utiliser les 4 premiers produits promo pour le hero slider
      state.heroPromoProducts = products.slice(0, 4);
    },
    
    setTrendingProducts(state, products) {
      state.trendingProducts = products;
    },
    
    setBestsellerProducts(state, products) {
      state.bestsellerProducts = products;
    },
    
    setNewArrivals(state, products) {
      state.newArrivals = products;
    },
    
    setSimilarProducts(state, products) {
      state.similarProducts = products;
    },
    
    // Mutations pour l'administration
    setAdminData(state, data) {
      console.log(data)
      state.admin.brands = data.brands || [];
      state.admin.categories = data.categories || [];
      state.admin.productModels = data.productModels || [];
      state.admin.products = data.products || [];
      state.admin.orders = data.orders || [];
      state.admin.users = data.users || [];
          state.admin.suppliers = data.suppliers || [];
    },
    
    setAdminBrands(state, brands) {
      state.admin.brands = brands;
    },
    
    setAdminCategories(state, categories) {
      state.admin.categories = categories;
    },
    
    setAdminProductModels(state, productModels) {
      state.admin.productModels = productModels;
    },
    
    setAdminProducts(state, products) {
      state.admin.products = products;
    },
    
    setAdminOrders(state, orders) {
      state.admin.orders = orders;
    },
    
    setAdminUsers(state, users) {
      state.admin.users = users;
    },
    
    addAdminBrand(state, brand) {
      state.admin.brands.push(brand);
    },
    
    updateAdminBrand(state, updatedBrand) {
      const index = state.admin.brands.findIndex(b => b.id === updatedBrand.id);
      if (index !== -1) {
        state.admin.brands.splice(index, 1, updatedBrand);
      }
    },
    
    deleteAdminBrand(state, id) {
      state.admin.brands = state.admin.brands.filter(b => b.id !== id);
    },
    
    addAdminCategory(state, category) {
      state.admin.categories.push(category);
    },
    
    updateAdminCategory(state, updatedCategory) {
      const index = state.admin.categories.findIndex(c => c.id === updatedCategory.id);
      if (index !== -1) {
        state.admin.categories.splice(index, 1, updatedCategory);
      }
    },
    
    deleteAdminCategory(state, id) {
      state.admin.categories = state.admin.categories.filter(c => c.id !== id);
    },
    
    addAdminProductModel(state, productModel) {
      state.admin.productModels.push(productModel);
    },
    
    updateAdminProductModel(state, updatedProductModel) {
      const index = state.admin.productModels.findIndex(pm => pm.id === updatedProductModel.id);
      if (index !== -1) {
        state.admin.productModels.splice(index, 1, updatedProductModel);
      }
    },
    
    deleteAdminProductModel(state, id) {
      state.admin.productModels = state.admin.productModels.filter(pm => pm.id !== id);
    },
    
    addAdminProduct(state, product) {
      state.admin.products.push(product);
    },
    
    updateAdminProduct(state, updatedProduct) {
      const index = state.admin.products.findIndex(p => p.id === updatedProduct.id);
      if (index !== -1) {
        state.admin.products.splice(index, 1, updatedProduct);
      }
    },
    
    deleteAdminProduct(state, id) {
      state.admin.products = state.admin.products.filter(p => p.id !== id);
    },
    
    updateAdminOrderStatus(state, { id, status }) {
      const order = state.admin.orders.find(o => o.id === id);
      if (order) {
        order.status = status;
        order.status_text = getStatusText(status);
      }
    },
    updateOrderPaymentStatus(state, { id, payment_status }) {
      const order = state.admin.orders.find(o => o.id === id);
      if (order) {
        order.payment_status = payment_status;
      }
    },
    // Dashboard mutations
    setDashboardProducts(state, products) {
      state.dashproducts = products;
    },
    
    setDashboardCategories(state, categories) {
      state.dashcategories = categories;
    },
    
    setDashboardOrders(state, orders) {
      state.dashorders = orders;
    },
    
    setDashboardUsers(state, users) {
      state.dashusers = users;
    },
    
    setDashboardBrands(state, brands) {
      state.dashbrands = brands;
    },
    
  // Mettre à jour le statut d'une commande dans admin.orders
  updateAdminOrderStatus(state, { id, status }) {
    const order = state.admin.orders.find(o => o.id === id);
    if (order) {
      order.status = parseInt(status);
      order.status_text = this._vm?.$options.methods?.getStatusLabel?.(status) || 
                         getStatusText(status);
    }
  },
  
  // Mettre à jour le statut de paiement d'une commande
  updateAdminOrderPaymentStatus(state, { id, payment_status }) {
    const order = state.admin.orders.find(o => o.id === id);
    if (order) {
      order.payment_status = parseInt(payment_status);
    }
  },
  
  // Mettre à jour le statut dans dashorders
  updateDashboardOrderStatus(state, { id, status }) {
    const order = state.dashorders.find(o => o.id === id);
    if (order) {
      order.status = parseInt(status);
      order.status_text = this._vm?.$options.methods?.getStatusLabel?.(status) || 
                         getStatusText(status);
    }
  },
  
  updateDashboardOrderPaymentStatus(state, { id, payment_status }) {
    const order = state.dashorders.find(o => o.id === id);
    if (order) {
      order.payment_status = parseInt(payment_status);
    }
  },
  
  // Mettre à jour le statut dans les commandes utilisateur
  updateUserOrderStatus(state, { id, status }) {
    const order = state.orders.find(o => o.id === id);
    if (order) {
      order.status = parseInt(status);
      order.status_text = this._vm?.$options.methods?.getStatusLabel?.(status) || 
                         getStatusText(status);
    }
  },
  
  // Mettre à jour localement une commande spécifique (utilisée après une mise à jour API)
  updateOrderInState(state, updatedOrder) {
    // Chercher dans admin.orders
    const adminIndex = state.admin.orders.findIndex(o => o.id === updatedOrder.id);
    if (adminIndex !== -1) {
      state.admin.orders.splice(adminIndex, 1, updatedOrder);
    }
    
    // Chercher dans dashorders
    const dashIndex = state.dashorders.findIndex(o => o.id === updatedOrder.id);
    if (dashIndex !== -1) {
      state.dashorders.splice(dashIndex, 1, updatedOrder);
    }
    
    // Chercher dans orders (utilisateur)
    const userIndex = state.orders.findIndex(o => o.id === updatedOrder.id);
    if (userIndex !== -1) {
      state.orders.splice(userIndex, 1, updatedOrder);
    }
  },

    setDashboardProductModels(state, models) {
      state.dashproductModels = models;
    },
    setproductnumber(state, number) {
    // console.log(number)
    state.productnumber = number;
  },
  
  },
  
  actions: {
    // Initialiser le store
    initializeStore({ commit }) {
      const token = localStorage.getItem('token');
      if (token) {
        commit('setToken', token);
      }
    },
     // Actions d'authentification
    async register({ commit, state }, userData) {
      try {
        const response = await axios.post(state.localhost + 'register', userData);
        const { user, token } = response.data;
        
        commit('setUser', user);
        commit('setToken', token);
        
        return { user, token };
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async login({ commit, state }, credentials) {
      try {
        const response = await axios.post(state.localhost + 'login', credentials);
        const { user, token } = response.data;
        
        commit('setUser', user);
        commit('setToken', token);
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        // Si rememberMe est true, stocker dans localStorage
        if (credentials.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
          localStorage.setItem('userEmail', credentials.email);
        } else {
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('userEmail');
        }
    
        // Charger les données utilisateur après connexion
        await this.dispatch('fetchUserData');
        
        return { user, token };
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async logout({ commit, state }) {
      try {
        if (state.token) {
          await axios.post(state.localhost + 'logout', {}, {
            headers: {
              Authorization: `Bearer ${state.token}`
            }
          });
        }
      } finally {
        commit('clearAuth');
        commit('clearCart');
        commit('setWishlists', []);
        commit('setOrders', []);
      }
    },
    
    // Actions pour la réinitialisation du mot de passe
    async forgotPassword({ commit, state }, email) {
      try {
        const response = await axios.post(state.localhost + 'password/email', {
          email: email
        });
        
        commit('setResetEmail', email);
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async resetPassword({ commit, state }, resetData) {
      try {
        const response = await axios.post(state.localhost + 'password/reset', resetData);
        
        // Si réinitialisation réussie, nettoyer l'email
        commit('setResetEmail', '');
        
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
  // Mettre à jour le statut d'une commande
  async updateOrderStatus({ commit, state }, { id, status }) {
    try {
      const token = state.token || localStorage.getItem('token');
      const response = await axios.put(state.localhost + `orders/${id}/status`, 
        { status }, 
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      const updatedOrder = response.data.order;
      
      // Mettre à jour l'état local
      commit('updateAdminOrderStatus', { id, status });
      commit('updateDashboardOrderStatus', { id, status });
      commit('updateUserOrderStatus', { id, status });
      
      // Optionnel: mettre à jour avec les données complètes de l'API
      commit('updateOrderInState', updatedOrder);
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      throw error.response?.data || error;
    }
  },
  
  // Mettre à jour le statut de paiement
  async updateOrderPaymentStatus({ commit, state }, { id, payment_status }) {
    try {
      const token = state.token || localStorage.getItem('token');
      const response = await axios.put(state.localhost + `orders/${id}/payment-status`, 
        { payment_status }, 
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      const updatedOrder = response.data.order;
      
      // Mettre à jour l'état local
      commit('updateAdminOrderPaymentStatus', { id, payment_status });
      commit('updateDashboardOrderPaymentStatus', { id, payment_status });
      commit('updateOrderInState', updatedOrder);
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut de paiement:', error);
      throw error.response?.data || error;
    }
  },
  
  // Mettre à jour plusieurs statuts en batch
  async updateOrdersStatusBatch({ dispatch }, updates) {
    try {
      const promises = updates.map(update => 
        dispatch('updateOrderStatus', update)
      );
      const results = await Promise.allSettled(promises);
      
      // Vérifier s'il y a des erreurs
      const errors = results.filter(r => r.status === 'rejected');
      if (errors.length > 0) {
        console.error('Certaines mises à jour ont échoué:', errors);
        throw new Error(`${errors.length} mises à jour ont échoué`);
      }
      
      return results.map(r => r.value);
    } catch (error) {
      console.error('Erreur lors de la mise à jour batch:', error);
      throw error;
    }
  },
  
  // Récupérer une commande spécifique (pour rafraîchir)
  async fetchOrder({ commit, state }, orderId) {
    try {
      const token = state.token || localStorage.getItem('token');
      const response = await axios.get(state.localhost + `orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      const order = response.data.order;
      commit('updateOrderInState', order);
      
      return order;
    } catch (error) {
      console.error('Erreur lors de la récupération de la commande:', error);
      throw error.response?.data || error;
    }
  },

     // Actions pour les fournisseurs
    async fetchSuppliers({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'suppliers', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('setSuppliers', response.data.suppliers);
        return response.data.suppliers;
      } catch (error) {
        console.error('Erreur lors du chargement des fournisseurs:', error);
        throw error;
      }
    },
    
    async fetchAdminSuppliers({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'admin/suppliers', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('setAdminSuppliers', response.data.suppliers);
        return response.data;
      } catch (error) {
        console.error('Erreur lors de la récupération des fournisseurs admin:', error);
        throw error;
      }
    },
    
    async saveSupplier({ commit, state }, supplierData) {
      try {
        const token = state.token || localStorage.getItem('token');
       
        
       
        
        const method = supplierData.id ? 'put' : 'post';
        const url = supplierData.id 
          ? state.localhost + `admin/suppliers/${supplierData.id}`
          : state.localhost + 'admin/suppliers';
        
        const response = await axios({
          method,
          url,
          data: supplierData,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const savedSupplier = response.data.supplier;
        if (supplierData.id) {
          commit('updateAdminSupplier', savedSupplier);
        } else {
          commit('addAdminSupplier', savedSupplier);
        }
        
        return savedSupplier;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde du fournisseur:', error);
        throw error;
      }
    },
    
    async deleteSupplier({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `admin/suppliers/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('deleteAdminSupplier', id);
        return true;
      } catch (error) {
        console.error('Erreur lors de la suppression du fournisseur:', error);
        throw error;
      }
    },
    
    async fetchSupplierStats({ state }, supplierId) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + `admin/suppliers/${supplierId}/stats`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        return response.data;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques du fournisseur:', error);
        throw error;
      }
    },
    
    // Mettre à jour l'action fetchDashboardData
    async fetchDashboardData({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'admin/dashboard', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const data = response.data;
        
        if (data.products) commit('setDashboardProducts', data.products);
        if (data.categories) commit('setDashboardCategories', data.categories);
        if (data.orders) commit('setDashboardOrders', data.orders);
        if (data.users) commit('setDashboardUsers', data.users);
        if (data.brands) commit('setDashboardBrands', data.brands);
        if (data.productModels) commit('setDashboardProductModels', data.productModels);
        if (data.suppliers) commit('setDashboardSuppliers', data.suppliers); // <-- Ajouté
        
        return data;
      } catch (error) {
        console.error('Erreur lors du chargement des données dashboard:', error);
        throw error;
      }
    },
    
    // Actions d'authentification
    async register({ commit, state }, userData) {
      try {
        const response = await axios.post(state.localhost + 'register', userData);
        const { user, token } = response.data;
        
        commit('setUser', user);
        commit('setToken', token);
        
        return { user, token };
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
   
    
    async logout({ commit, state }) {
      try {
        if (state.token) {
          await axios.post(state.localhost + 'logout', {}, {
            headers: {
              Authorization: `Bearer ${state.token}`
            }
          });
        }
      } finally {
        commit('clearAuth');
        commit('clearCart');
        commit('setWishlists', []);
        commit('setOrders', []);
      }
    },
    
    // Actions pour récupérer les données utilisateur
    async fetchUserData({ commit, state, dispatch }) {
      try {
        const token = state.token || localStorage.getItem('token');
        if (!token) return;
        
        const response = await axios.get(state.localhost + 'getuser', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const data = response.data;
        
        // Mettre à jour les données utilisateur
        commit('setUser', data.user);
        
        // Mettre à jour le panier
        if (data.cart) {
          commit('setCart', data.cart);
        }
        
        // Mettre à jour les commandes
  
        if (data.orders) {
          commit('setOrders', data.orders);
        }
        
        // Mettre à jour la wishlist
        if (data.wishlists) {
          commit('setWishlists', data.wishlists);
        }
        
        // Mettre à jour les catégories
        if (data.categories) {
          commit('setCategories', data.categories);
        }
        
        // Mettre à jour les marques
        if (data.brands) {
          commit('setBrands', data.brands);
        }
        
        // Mettre à jour les produits
        if (data.allProducts) {
          commit('setAllProducts', data.allProducts);
        }
        
        // Mettre à jour les produits promo
        if (data.promoProducts) {
          commit('setPromoProducts', data.promoProducts);
        }
        
        // Mettre à jour les produits tendance
        if (data.trendingProducts) {
          commit('setTrendingProducts', data.trendingProducts);
        }
        
        // Mettre à jour les meilleures ventes
        if (data.bestSellingProducts) {
          commit('setBestsellerProducts', data.bestSellingProducts);
        }
        
        // Mettre à jour les nouveautés
        if (data.newArrivals) {
          commit('setNewArrivals', data.newArrivals);
        }
        
        return data;
      } catch (error) {
        console.error('Erreur lors du chargement des données utilisateur:', error);
        throw error;
      }
    },
    
    // Charger les données pour les utilisateurs non connectés
    async fetchOfflineData({ commit, state }) {
      try {
    
        let response=null
        if (localStorage.getItem('token')!==""&&localStorage.getItem('token')!==null&&localStorage.getItem('token')!==undefined){
         
           let token=localStorage.getItem('token')
             response = await axios.get(state.localhost +'getuser',{headers:{
              Authorization: `Bearer ${token}`
            }});
            
        }else{
        
          
             response = await axios.get(state.localhost +'offdata');
        }
       
      
        const data = response.data;
        
       commit('setUser', data.user);
        
        // Mettre à jour le panier
        if (data.cart) {
          commit('setCart', data.cart);
        }
        
        // Mettre à jour les commandes
  
        if (data.orders) {
          commit('setOrders', data.orders);
        }
        
        // Mettre à jour la wishlist
        if (data.wishlists) {
          commit('setWishlists', data.wishlists);
        }
        
        // Mettre à jour les catégories
        if (data.categories) {
          commit('setCategories', data.categories);
        }
        
        // Mettre à jour les marques
        if (data.brands) {
          commit('setBrands', data.brands);
        }
        
        // Mettre à jour les produits
        if (data.allProducts) {
          commit('setAllProducts', data.allProducts);
        }
        
        // Mettre à jour les produits promo
        if (data.promoProducts) {
          commit('setPromoProducts', data.promoProducts);
        }
        
        // Mettre à jour les produits tendance
        if (data.trendingProducts) {
          commit('setTrendingProducts', data.trendingProducts);
        }
        
        // Mettre à jour les meilleures ventes
        if (data.bestSellingProducts) {
          commit('setBestsellerProducts', data.bestSellingProducts);
        }
// console.log(data.products_count)
        commit('setproductnumber',data.products_count);
        // Mettre à jour les nouveautés
        if (data.newArrivals) {
          commit('setNewArrivals', data.newArrivals);
        }
        
        return data;
      } catch (error) {
        console.error('Erreur lors du chargement des données hors ligne:', error);
        throw error;
      }
    },
    
    // Actions pour le panier
    async addToCart({ commit, state }, productData) {
      try {
        const token = state.token || localStorage.getItem('token');
        if (!token) {
          throw new Error('Vous devez être connecté pour ajouter au panier');
        }
        
        const response = await axios.post(state.localhost + 'cart/add', productData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const cartItem = response.data.cart_item;
        commit('addToCart', cartItem);
        
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async incrementCartItem({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + `cart/increment/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('incrementCartItem', id);
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async decrementCartItem({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + `cart/decrement/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        if (response.data.deleted) {
          commit('removeFromCart', id);
        } else {
          commit('decrementCartItem', id);
        }
        
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async removeFromCart({ commit, state }, id) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(state.localhost + `cart/supprimer/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('removeFromCart', id);
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async clearCart({ commit, state }) {
      try {
        const token =  localStorage.getItem('token');
        await axios.delete(state.localhost + 'cart/vider', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('clearCart');
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async updateCartSize({ commit, state }, { id, size }) {
      try {
        const token = localStorage.getItem('token');
        await axios.post(state.localhost + 'cart/setsize', { id, size }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('updateCartItem', { id, updates: { size } });
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async updateCartColor({ commit, state }, { id, color }) {
      try {
        const token =  localStorage.getItem('token');
        await axios.post(state.localhost + 'cart/setcolor', { id, color }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('updateCartItem', { id, updates: { color } });
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    // Actions pour les commandes
    async placeOrder({ commit, state }, orderData) {
  try {
    commit('setLoading', true);
    commit('clearError');
    
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Vous devez être connecté pour passer commande');
    }
    
    const response = await axios.post(state.localhost + 'commander', orderData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    const order = response.data.order;
    commit('addOrder', order);
    commit('clearCart');
    
    return response.data;
    
  } catch (error) {
    commit('setError', error.response?.data || error.message);
    throw error;
  } finally {
    commit('setLoading', false);
  }
},
    
    async fetchOrders({ commit, state }) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'getorders', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('setAdminOrders', response.data.orders);
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    // Actions pour la wishlist
    async addToWishlist({ commit, state }, productId) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.post(state.localhost + 'addToWishlist', productId, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('addToWishlist', response.data.wishlist_item);
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async removeFromWishlist({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `removeWishlist/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('removeFromWishlist', id);
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    // Actions pour les produits
    async fetchProducts({ commit, state }, categoryId = null) {
      try {
        const url = categoryId 
          ? state.localhost + `products/category/${categoryId}`
          : state.localhost + 'products';
          
        const response = await axios.get(url);
        commit('setAllProducts', response.data.products);
        console.log(response.data.products)
        return response.data.products;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    async fetchProduct({ commit, state }, productId) {
      try {
        const response = await axios.get(state.localhost + `product/${productId}`);
        
        if (response.data.similar_products) {
          commit('setSimilarProducts', response.data.similar_products);
        }
        
        return response.data.product;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
    
    // Actions pour l'administration
    async fetchAdminData({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'data', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const data = response.data;
        const adminData = {
          brands: data.brands || [],
          categories: data.categories || [],
          productModels: data.product_models || [],
          products: data.articles || [],
          orders: data.orders || [],
          users: data.users || [],
          suppliers: data.suppliers || []
        };
        
        commit('setAdminData', adminData);
        return adminData;
      } catch (error) {
        console.error('Erreur lors de la récupération des données admin:', error);
        throw error;
      }
    },
    
    async fetchAdminOrders({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'admin/orders', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('setAdminOrders', response.data.orders);
        return {
          orders: response.data.orders,
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          total: response.data.total,
          has_more: response.data.has_more
        };
      } catch (error) {
        console.error('Erreur lors de la récupération des commandes admin:', error);
        throw error;
      }
    },
    
    async saveBrand({ commit, state }, brandData) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.post(state.localhost + 'createbrand', brandData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const savedBrand = response.data.brand;
        if (brandData.id) {
          commit('updateAdminBrand', savedBrand);
        } else {
          commit('addAdminBrand', savedBrand);
        }
        
        return savedBrand;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de la marque:', error);
        throw error;
      }
    },
    
    async deleteBrand({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `deletebrand/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('deleteAdminBrand', id);
        return true;
      } catch (error) {
        console.error('Erreur lors de la suppression de la marque:', error);
        throw error;
      }
    },
    
    async saveCategory({ commit, state }, categoryData) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.post(state.localhost + 'savecategorie', categoryData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const savedCategory = response.data.categorie;
        if (categoryData.id) {
          commit('updateAdminCategory', savedCategory);
        } else {
          commit('addAdminCategory', savedCategory);
        }
        
        return savedCategory;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de la catégorie:', error);
        throw error;
      }
    },
    
    async deleteCategory({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `deletecategorie/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('deleteAdminCategory', id);
        return true;
      } catch (error) {
        console.error('Erreur lors de la suppression de la catégorie:', error);
        throw error;
      }
    },
    
    async saveProductModel({ commit, state }, productModelData) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.post(state.localhost + 'saveproduct_model', productModelData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const savedProductModel = response.data.product_model;
        if (productModelData.id) {
          commit('updateAdminProductModel', savedProductModel);
        } else {
          commit('addAdminProductModel', savedProductModel);
        }
        
        return savedProductModel;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde du modèle de produit:', error);
        throw error;
      }
    },
    
    async deleteProductModel({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `deleteproduct_model/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('deleteAdminProductModel', id);
        return true;
      } catch (error) {
        console.error('Erreur lors de la suppression du modèle de produit:', error);
        throw error;
      }
    },
    // Dans votre store
async fetchDashboardStats({ commit, state }) {
  try {
    const response = await axios.get(state.localhost + 'admin/dashboard/stats', {
      headers: { Authorization: `Bearer ${state.token}` }
    });
    commit('setDashboardStats', response.data.stats);
    return response.data;
  } catch (error) {
    console.error('Erreur lors du chargement des stats dashboard:', error);
    throw error;
  }
},
    async saveProduct({ commit, state }, productData) {
      try {
        const token = state.token || localStorage.getItem('token');
        const formData = new FormData();
        
        // Ajouter les champs au FormData
        Object.keys(productData).forEach(key => {
          if (key !== 'cover_image' && key !== 'additionalImages') {
            formData.append(key, productData[key]);
          }
        });
        
        // Ajouter le fichier cover_image si présent
        if (productData.cover_image instanceof File) {
          formData.append('cover_image', productData.cover_image);
        }
        
        // Ajouter les fichiers additionalImages si présents
        if (productData.additionalImages && Array.isArray(productData.additionalImages)) {
          productData.additionalImages.forEach((file, index) => {
            if (file instanceof File) {
              formData.append(`additionalImages[${index}]`, file);
            }
          });
        }
        
        const response = await axios.post(state.localhost + 'saveproduct', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        
        const savedProduct = response.data.product;
        if (productData.id) {
          commit('updateAdminProduct', savedProduct);
        } else {
          commit('addAdminProduct', savedProduct);
        }
        
        return savedProduct;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde du produit:', error);
        throw error;
      }
    },
    
    async deleteProduct({ commit, state }, id) {
      try {
        const token = state.token || localStorage.getItem('token');
        await axios.delete(state.localhost + `deleteproduct/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('deleteAdminProduct', id);
        return true;
      } catch (error) {
        console.error('Erreur lors de la suppression du produit:', error);
        throw error;
      }
    },
    
    async updateOrderStatus({ commit, state }, { id, status }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.put(state.localhost + `orders/${id}/status`, { status }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        commit('updateAdminOrderStatus', { id, status });
        return response.data;
      } catch (error) {
        console.error('Erreur lors de la mise à jour du statut de commande:', error);
        throw error;
      }
    },
    
    // Actions pour le dashboard
    async fetchDashboardData({ commit, state }) {
      try {
        const token = state.token || localStorage.getItem('token');
        const response = await axios.get(state.localhost + 'admin/dashboard', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const data = response.data;
        
        if (data.products) commit('setDashboardProducts', data.products);
        if (data.categories) commit('setDashboardCategories', data.categories);
        if (data.orders) commit('setDashboardOrders', data.orders);
        if (data.users) commit('setDashboardUsers', data.users);
        if (data.brands) commit('setDashboardBrands', data.brands);
        if (data.productModels) commit('setDashboardProductModels', data.productModels);
        
        return data;
      } catch (error) {
        console.error('Erreur lors du chargement des données dashboard:', error);
        throw error;
      }
    },
  },
  
  modules: {}
});

// Helper function pour convertir le statut en texte
function getStatusText(status) {
  switch (status) {
    case 0: return 'Rejeté';
    case 1: return 'En cours';
    case 2: return 'Accepté';
    case 3: return 'Expédié';
    case 4: return 'Livré';
    default: return 'Inconnu';
  }
}
